import React from 'react';
import StudentLayout from '../components/StudentLayout';

export default function Feedback() {
  return (
    <StudentLayout title="Feedback">
      <h2>Feedback</h2>
      <p>Submit and view feedback here.</p>
    </StudentLayout>
  );
}
